module.exports = __webpack_public_path__ + "img/articleNotStarted.0a651815.svg";